function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import PropTypes from "prop-types";
import React, { Children, cloneElement } from "react";
import classnames from "classnames";
import Base from "../Base/Base";
import { isComponent } from "@brandwatch/axiom-utils";
import { ButtonIconRef } from "./ButtonIcon";
import "./Button.css";
export default function Button(_ref) {
  let {
    active,
    children,
    className,
    color = "accent",
    disabled,
    joined,
    joinedLeft,
    joinedRight,
    shape = "rectangle",
    variant = "primary",
    size = "medium",
    full,
    ...rest
  } = _ref;
  const childrenArray = Children.toArray(children);
  const iconOnly = childrenArray.length === 1 && isComponent(childrenArray[0], ButtonIconRef);
  const classes = classnames("ax-button", `ax-button--${color}`, `ax-button--${variant}`, `ax-button--${shape}-${size}`, {
    "ax-button--active": active,
    "ax-button--joined": joined,
    "ax-button--joined-left": joinedLeft,
    "ax-button--joined-right": joinedRight,
    "ax-button--icon-only": shape === "rectangle" && iconOnly,
    "ax-button--full": full === true,
    [`ax-button--full--${full}`]: typeof full === "string"
  }, className);
  const mappedChildren = childrenArray.map((child, index, array) => !isComponent(child, ButtonIconRef) ? child : /*#__PURE__*/cloneElement(child, {
    isEnd: index === array.length - 1,
    isStart: index === 0
  }));
  return /*#__PURE__*/React.createElement(Base, _extends({
    Component: "button"
  }, rest, {
    className: classes,
    disabled: disabled
  }), mappedChildren);
}